module.exports = __webpack_public_path__ + "img/Abstract-Watercolor-Half-face-Lion-Tattoo-On-Upper-Back-1.jpg";